import React from 'react';
import { Star, ShieldCheck, Lock } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full px-4 py-6 md:py-10 max-w-7xl mx-auto" data-id="element-79">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 items-center" data-id="element-80">
        <div className="flex flex-col space-y-3" data-id="element-81">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-text-main" data-id="element-82">
            Rompé los patrones que te frenan y sentite en paz con quien sos —
            sin años de terapia
          </h1>
          <p className="text-sm md:text-base text-text-muted font-medium leading-snug" data-id="element-83">
            <strong className="text-text-main" data-id="element-84">
              3 sistemas completos + 100 preguntas terapéuticas guiadas
            </strong>{' '}
            · Acceso inmediato · Funciona aunque ya lo intentaste todo
          </p>

          <a href="https://tulibrodigital.lat/products/patrones-emocionales" onClick={() => {
          const w = window as any;
          w.fbq && w.fbq('track', 'AddToCart');
        }} className="block w-full text-center bg-accent text-white font-bold text-lg py-3 px-6 rounded-xl shadow-md active:scale-95 transition-transform" data-id="element-85">
            QUIERO EL SISTEMA →
          </a>

          <div className="flex flex-wrap items-center gap-3 text-xs text-text-muted font-medium" data-id="element-86">
            <div className="flex items-center text-bonus" data-id="element-87">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-88" />)}
            </div>
            <div className="flex items-center gap-1" data-id="element-89">
              <ShieldCheck className="w-3 h-3 text-primary" data-id="element-90" />
              <span data-id="element-91">Compra Verificada</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-92">
              <Lock className="w-3 h-3 text-primary" data-id="element-93" />
              <span data-id="element-94">Pago Seguro</span>
            </div>
          </div>
        </div>

        <div className="relative w-full aspect-[4/3] md:aspect-[4/5] bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100" data-id="element-95">
          <img src="https://cdn.magicpatterns.com/uploads/48YCahmiMmccbHSExHewHD/20260408_2133_Image_Generation_simple_compose_01knqtfjq1egxt7ykr1d03y4tj.png" alt="Sistema de Sanación Emocional Integral" className="absolute inset-0 w-full h-full object-cover" data-id="element-96" />
        </div>
      </div>
    </section>;
}